export { OrderDetailV2OrderData } from "./OrderDetailV2OrderData";
